import { useMutation } from '@tanstack/react-query';
import { myProfileApi } from '../api/myProfileApi';
import type { ChangePasswordRequest } from '../types/myProfile';

/**
 * POST /api/eraf/me/password-change — 비밀번호 변경
 *
 * 성공 직후 BE 가 모든 세션을 폐기하므로 다음 요청에서 401 이 발생.
 * 호출자가 successHandler 에서 /login 으로 리다이렉트 처리해야 함.
 * queryKey 무효화를 하지 않음 — 토큰 폐기로 UI 자체가 리다이렉트됨.
 */
export function useChangePassword() {
  return useMutation({
    mutationFn: (body: ChangePasswordRequest) => myProfileApi.changePassword(body),
  });
}
